<template>
  <div style="height: 100%">
    <div v-if="parent.isModuleGroup && edit && !dragMoving && moduleGroupVisibleTooltip"
         @click="onModuleTipClick(parent)"
         class="text-hover-tip module-group-tip"
         :style="moduleTipStyle"><i class="el-icon-close" @click="onCloseModuleTip"></i> 点击此处修改模块内容
    </div>
    <template v-for="(item, index) in children">
      <self-option-list :dragMoving="dragMoving" :key="item.key" :alt="item.originName"
                        v-if="item.children && item.children.length > 0"
                        class="self-option-list"
                        :class="hoverModuleGroupClass(item)"
                        :edit="edit"
                        :enterKeydownFunc="enterKeydownFunc"
                        :addItemFunc="addItemFunc"
                        :parent="item"
                        :editorObj="editorObj"
                        :attrCover="attrCover"
                        :moduleCover="moduleCover"
                        :rootScale="rootScale"
                        :layerResize="layerResize"
                        @addCache="addCache"
                        @onOpenGroupDialog="onOpenGroupDialog"
                        @onMaterialImgClick="onMaterialImgClick"
                        @click.native="onOptionListClick(item, parent)"
                        @onOptionListClick="onOptionListClick"
                        @onTextBlur="onTextBlur"
                        @onTextFocus="onTextFocus"
                        @onItemClick="onItemClick"
                        @onCssTextClick="onCssTextClick"
                        @onTextHover="onTextHover"
                        @onCutImg="onCutImg"
                        @onTableClick="onTableClick"
                        @mouseenter.native="onmouseenter(item)"
                        :style="getParentStyle(item, index)" :children="item.children"></self-option-list>
      <!--</el-popover>-->
      <self-option v-else-if="selfOptionVisible(item, parent)"
                   :style="getStyle(item, index)"
                   :class="hoverClass(item)"
                   :parent="parent"
                   :edit="edit"
                   :item="item"
                   :key="item.key"
                   :attrCover="attrCover"
                   :dragMoving="dragMoving"
                   :rootScale="rootScale"
                   :layerResize="layerResize"
                   @addCache="addCache"
                   @onKeydown="onKeydown"
                   @onOpenGroupDialog="onOpenGroupDialog"
                   @onMaterialImgClick="onMaterialImgClick"
                   @onTextBlur="onTextBlur"
                   @onTextFocus="onTextFocus"
                   @onItemClick="onItemClick"
                   @onCssTextClick="onCssTextClick"
                   @onTextHover="onTextHover"
                   @onCutImg="onCutImg"
                   @onTableClick="onTableClick"
      ></self-option>
    </template>
  </div>
</template>
<script>
    import selfOption from "./self-option";
    import {img_horizontal, img_two_direction} from '@/const';
    export default {
        name: 'self-option-list',
        components: {selfOption},
        props: {
            children: {
                type: Array,
                default() {
                    return [];
                }
            },
            parent: {
                type: Object, default() {
                    return {}
                }
            },
            editorObj: {
                type: Object, default() {
                    return {}
                }
            },
            addItemFunc: {
                type: Function, default: null
            },
            enterKeydownFunc: {
                type: Function, default: null
            },
            clickModuleGroupFunc: {
                type: Function, default: null
            },
            dragMoving: {
                type: Boolean,
                default: true
            },
            edit: {
                type: Boolean,
                default: true
            },
            attrCover: {
                type: Boolean,
                default: false
            },
            moduleCover: {
                type: Boolean,
                default: false
            },
            rootScale: {
                type: Number,
                default: 1
            },
            layerResize: {
                type: Boolean, default: false
            }
        },
        data() {
            return {
            }
        },
        computed: {
            selectedItem() {
                return this.$store.state.templateGroup.selectedItem;
            },
            moduleTipStyle() {
                let height = parseInt(32 / this.rootScale);
                let fontSize = parseInt(14 / this.rootScale);
                return `font-size:${fontSize}px;height:${height}px;line-height:${height}px;left: 0px;`
            },
            moduleGroupVisibleTooltip(){
               return this.$store.state.templateGroup.moduleGroupVisibleTooltip;
            }
        },
        methods: {
            hoverModuleGroupClass(item) {
                if (!this.edit) {
                    return;
                }
                if (!item.isModuleGroup) {
                    return;
                }
                if (item.hasOwnProperty('disabled') && !item.disabled) { // edit可能为空
                    return;
                }
                let classArr = ['mouse-hover'];
                if (item === this.selectedItem) {
                    classArr.push('item-active');
                }
                return classArr.join(' ');
            },
            hoverClass(item) {
                let multiImgs = this.$store.state.templateGroup.multiImgItems;
                if (multiImgs.length > 0 && item.type === 'img') {
                    let hasVal = multiImgs.some((obj) => {
                        return item === obj;
                    });
                    if (hasVal) {
                        return 'item-active';
                    }
                }
                if (!this.edit) {
                    return;
                }
                if (item.hasOwnProperty('disabled') && item.disabled) {
                    return;
                }
                let classArr = [];

                if (item === this.selectedItem) {
                    classArr.push('item-active');
                }
                let isText = item.type === 'text';
                let isImg = item.type === 'img' && !item.disabled;
                if (isText || isImg || item.isEditableTable) {
                    classArr.push('mouse-hover');
                }
                return classArr.join(' ');
            },
            isNotNull(value) {
                return value !== null && value !== undefined && value != 'auto';
            },
            getParentStyle(item, index) {
                let parent = this.parent || {};
                let zIndex = this.isNotNull(item.zIndex) ? (+item.zIndex + 1) : index + 1;
                let pLeft = +parent.left || 0;
                let pTop = +parent.top || 0;
                let left = +item.left;
                let top = +item.top;
                left = left - pLeft;
                top = top - pTop;
                // left = left < 0 ? 0 : left;
                // top = top < 0 ? 0 : top;
                return `z-index:${zIndex};left: ${left}px;top:${top}px;width: ${item.width}px;height:${item.height}px;`;
            },
            getStyle(item, index) {
                let parent = this.parent || {};
                let zIndex = this.isNotNull(item.zIndex) ? (+item.zIndex + 1) : index + 1;
                let pLeft = +parent.left || 0;
                let pTop = +parent.top || 0;
                let left = +item.left;
                let top = +item.top;
                left = left - pLeft;
                top = top - pTop;
                // left = left < 0 ? 0 : left;
                let baseStyle = [
                    `text-align:${item.textAlign}`,
                    `z-index:${zIndex};`,
                    `top:${top}px`,
                    `left: ${left}px`,
                ]
                if (item.type === 'text') {
                    if (['vertical-lr', 'vertical-rl'].indexOf(item.writingMode) > -1) {
                        baseStyle.push(`height: ${item.height}px`);
                    }
                    let dc = item.direction || this.parent.direction;
                    let imgExtend = [img_horizontal, img_two_direction].indexOf(dc) > -1;
                    if (imgExtend) {
                        baseStyle.push('width: auto');
                    }else{
                        baseStyle.push(`width: ${item.width}px`);
                    }
                    baseStyle.push(`writing-mode: ${item.writingMode}`);
                    return baseStyle.join(';');
                } else {
                    baseStyle.push(`left: ${left}px`);
                    baseStyle.push(`width: ${item.width}px`);
                    if(item.isBgImg && top > 0 && !item.isPageBgImg){
                        baseStyle.push(`height: calc(100% - ${top}px) !important`)
                    }else{
                        baseStyle.push(`height:${item.height}px`);
                    }
                    return baseStyle.join(';');
                }
            },
            onKeydown(item, minusOrPlus, height) {
                this.enterKeydownFunc && this.enterKeydownFunc(item, minusOrPlus, height);
            },
            onOpenGroupDialog(item) {
                this.$emit('onOpenGroupDialog', item);
            },
            onOptionListClick(item, parent) {
                let isNotModuleFromBeforeItem = this.selectedItem && this.selectedItem.isModuleGroup === undefined;
                if (isNotModuleFromBeforeItem) { // 之前选择是的图片或文本，模块组的点击事件不触发
                    return;
                }
                if (item.isModuleGroup) {
                    this.$emit('onOptionListClick', item);
                    this.$store.commit('templateGroup/set_selected_item', item);
                }
            },
            onModuleTipClick(item) {
                this.$emit('onOptionListClick', item);
                this.$store.commit('templateGroup/set_selected_item', item);
            },
            onMaterialImgClick(item, ev) {
                this.$emit('onMaterialImgClick', item, ev);
            },
            setWidthByText(ev, item, parent) {
                let textWidth = ev.target.offsetWidth;
                let oldWidth = +item.width;
                if (textWidth !== oldWidth) {
                    parent.width = +parent.width + (textWidth - oldWidth);
                    item.width = textWidth;
                }
            },
            onTextBlur(ev, item) {
                if (this.parent.isMoveByText) {
                    this.setWidthByText(ev, item, this.parent);
                }
                if (this.parent.isModuleGroup) {
                    this.$store.commit('templateGroup/set_tooltip', true)
                }
                this.$emit('onTextBlur', ev, item)
            },
            onTextFocus(item) {
                if (this.parent.isModuleGroup) {
                    this.$store.commit('templateGroup/set_tooltip', false)
                }
                this.$emit('onTextFocus', item)
            },
            onItemClick(item, parent, ev) {
                this.$emit('onItemClick', item, parent, ev);
            },
            onCssTextClick(item) {
                this.$emit('onCssTextClick', item);
            },
            onTextHover(item) {
                this.$emit('onTextHover', item);
            },
            addCache() {
                this.$emit('addCache');
            },
            onCutImg(item) {
                this.$emit('onCutImg', item)
            },
            selfOptionVisible(item, parent) {
                // if (this.layerResize && this.selectedItem && this.selectedItem.type === 'text') {
                //     // 设置文本属性时，弹出拖拽框，复制选中元素到拖拽框中，并隐藏真实的元素
                //     return !(item === this.selectedItem);
                // } else {
                //     return !item.hide;
                // }
                return !item.hide;
            },
            onTableClick(item) {
                this.$emit('onTableClick', item)
            },
            onCloseModuleTip(){
                window.notTriggerMouseEnter = true; // 关闭模块组提示div时，会触发mouseenter，需要阻止此次事件
                this.$store.commit('templateGroup/set_tooltip', false);
                setTimeout(() => {
                    window.notTriggerMouseEnter = false;
                })
            },
            onmouseenter(item){
                if(item.isModuleGroup && !window.notTriggerMouseEnter){
                    this.$store.commit('templateGroup/set_tooltip', true);
                }
            }
        }
    }
</script>